<script lang="ts">
	import * as Popover from "#lib/web-ui/ui/popover/index.js";
	import InfoIcon from "@lucide/svelte/icons/info";

	let {
		content
	}: {
		content: string;
	} = $props();
</script>

<!-- Info Popover -->
<Popover.Root>
	<Popover.Trigger class="inline-block">
		<InfoIcon class="ml-2 h-4 w-4" />
	</Popover.Trigger>
	<Popover.Content class="max-w-xs rounded border p-6">
		<p class="text-muted-foreground text-sm font-normal">
			{content}
		</p>
	</Popover.Content>
</Popover.Root>
